import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaExternalLinkAlt, FaThumbsUp, FaCommentDots } from 'react-icons/fa';

import { useBlogContext } from '../Context/BlogContext';
import PopUp from './PopUp';

const BlogCards = ({ blog, handleLikes, handleDisLikes }) => {
  const { currentUser } = useBlogContext();

  const [show, setShow] = useState(false);

  const checkLikes = (uid) => {
    return blog.likes.some((item) => item.uid === uid);
  };

  const displayMsg = (likes) => {
    const liked = likes.map((like) => like.name);

    const [first, second, ...rest] = liked;
    if (liked.length === 1) {
      return `${liked[0]} liked your post`;
    }

    if (likes.length === 2) {
      return `${first} and ${second} liked your post`;
    }

    if (likes.length === 3) {
      return `${first}, ${second} and ${rest.length} other liked your post`;
    }
    if (likes.length > 3) {
      return `${first}, ${second} and ${rest.length} others liked your post`;
    }
  };

  const addText = (
    <Link to={`/blog/${blog.id}`}>
      {blog.content.length > 50 && (
        <span className=' flex text-sm items-center gap-2  text-blue-400'>
          Read more <FaExternalLinkAlt size='10px' color='black' />
        </span>
      )}
    </Link>
  );

  const handlePop = () => {
    setShow(!show);
  };

  return (
    <div className='space-y-2  mb-4'>
      <Link to={`/blog/${blog.id}`}>
        {' '}
        <h3 className='text-lg capitalize text-gray-800 font-bold'>
          {blog.title}
        </h3>{' '}
      </Link>

      <p className='text-xs text-gray-500'>{blog.datetime}</p>
      <p className='text-gray-500 md:text-base  text-sm text-justify'>
        {blog.content.length > 50
          ? blog.content.slice(0, 400) + '...'
          : blog.content}
        {addText}
      </p>
      <div className='flex'>
        {checkLikes(currentUser.uuid) ? (
          <button
            onClick={() => handleDisLikes(blog.id)}
            className='border rounded-full w-14 px-1 border-gray-400'
          >
            <span className='flex items-center text-gray-700  gap-2 p-1 text-sm'>
              <FaThumbsUp color='#f7b950' /> {blog.likes.length}
            </span>
          </button>
        ) : (
          <button
            onClick={() => handleLikes(blog.id)}
            className='border rounded-full w-14 px-1 border-gray-400'
          >
            <span className='flex items-center text-gray-700  gap-2 p-1 text-sm'>
              <FaThumbsUp color='#f7b950' /> {blog.likes.length}
            </span>
          </button>
        )}
        <Link to={`/blog/${blog.id}`}>
          <button>
            <span className='flex items-center text-gray-700  gap-2 p-1 text-sm'>
              <FaCommentDots />
              {blog.comments.length === 1
                ? `${blog.comments.length} reply`
                : blog.comments.length > 1
                ? `${blog.comments.length} replies`
                : `reply `}
            </span>
          </button>
        </Link>
      </div>

      <div className='text-gray-500 cursor-pointer text-xs' onClick={handlePop}>
        {displayMsg(blog.likes)}
      </div>

      {show ? <PopUp blog={blog} handlePop={handlePop} /> : null}
    </div>
  );
};

export default BlogCards;
